import script from "./OutrightFixture.vue?vue&type=script&setup=true&lang=js"
export * from "./OutrightFixture.vue?vue&type=script&setup=true&lang=js"

import "./OutrightFixture.vue?vue&type=style&index=0&id=09f80519&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f80519"]])

export default __exports__